module.exports = __webpack_public_path__ + "img/wechat_message_icon.d64737fe.png";